import { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { hasMarketingConsent, onMarketingConsentChange } from "@/lib/marketingConsent";
import { initTikTok, disableTikTok, trackPageView } from "@/lib/tiktokPixel";

// Zentrale, globale TikTok-Steuerung für die gesamte SPA.
// - Lädt/initialisiert den Pixel NUR bei Marketing-Einwilligung.
// - Sendet PageView bei erlaubtem Erstaufruf und bei jedem SPA-Routenwechsel (dedupliziert pro Pfad).
// - Widerruf -> keine weiteren Events.
export default function TikTokManager() {
  const { pathname } = useLocation();
  const lastPath = useRef(null);
  const [consent, setConsent] = useState(hasMarketingConsent());

  useEffect(() => onMarketingConsentChange(setConsent), []);

  useEffect(() => {
    if (!consent) {
      disableTikTok();
      lastPath.current = null;
      return;
    }
    initTikTok();
    if (lastPath.current !== pathname) {
      lastPath.current = pathname;
      trackPageView();
    }
  }, [consent, pathname]);

  return null;
}
